module.exports = __webpack_public_path__ + "media/images/app/collections/collection-hoop-3b36a7088db28aef9a711944f6e7dbd9.webp";